import i18n from 'i18next';
import { en, fr, es, it, ptBR, ptPT, se } from '../../translations';
import { initReactI18next } from 'react-i18next';
import { getLang } from '../../utils/getLang';

const resources = {
  en: {
    translation: en,
  },
  es: {
    translation: es,
  },
  fr: {
    translation: fr,
  },
  it: {
    translation: it,
  },
  'pt-BR': {
    translation: ptBR,
  },
  'pt-PT': {
    translation: ptPT,
  },
  se: {
    translation: se,
  },
};

i18n.use(initReactI18next).init({
  resources,
  fallbackLng: 'en',
  lng: getLang(),
  keySeparator: false,
  interpolation: {
    escapeValue: false, // not needed for react!!
  },
});

i18n.on('languageChanged', (lng) => {
  if (typeof localStorage !== 'undefined') {
    localStorage.setItem('i18nextLng', lng);
  }
});

export default i18n;
